import {Values} from "@wix/devzai-utils-common";

export const DoppeAutoServiceType = {
    Latest: 'Latest'
} as const;

export type DoppeAutoServiceType = Values<typeof DoppeAutoServiceType>;